var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoiceRecorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 29.952,
    viewBox: "0 0 34 29.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "voice-recorder",
    transform: "translate(0 -30.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(7.881 46.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M136.918,272.033a1,1,0,0,0-2,0,7.123,7.123,0,0,1-14.244,0,1,1,0,1,0-2,0,9.084,9.084,0,0,0,8.12,8.885v2.1h-3.128a1,1,0,1,0,0,2h8.254a1,1,0,1,0,0-2H128.8v-2.1A9.084,9.084,0,0,0,136.918,272.033Z",
    transform: "translate(-118.68 -271.035)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(11.875 30.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M183.945,30.474a5.113,5.113,0,0,0-5.125,4.992V47.447a5.127,5.127,0,0,0,10.25,0V35.466A5.114,5.114,0,0,0,183.945,30.474Z",
    transform: "translate(-178.82 -30.474)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(29.078 31.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M439.586,49.151a1,1,0,0,0-1.412,1.412,8.984,8.984,0,0,1,0,12.707,1,1,0,0,0,1.412,1.412,10.98,10.98,0,0,0,0-15.531Z",
    transform: "translate(-437.881 -48.858)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(26.252 34.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M397.036,91.7a1,1,0,0,0-1.412,1.412,4.982,4.982,0,0,1,0,7.056,1,1,0,0,0,1.412,1.412,6.978,6.978,0,0,0,0-9.88Z",
    transform: "translate(-395.332 -91.407)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(23.43 37.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M354.529,134.207a1,1,0,0,0-1.412,1.412.995.995,0,0,1,0,1.411,1,1,0,1,0,1.412,1.412,2.991,2.991,0,0,0,0-4.235Z",
    transform: "translate(-352.824 -133.914)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(0 31.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M2,56.915a8.923,8.923,0,0,1,2.633-6.353A1,1,0,1,0,3.217,49.15a10.98,10.98,0,0,0,0,15.531,1,1,0,0,0,1.412-1.412A8.925,8.925,0,0,1,2,56.915Z",
    transform: "translate(0 -48.857)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(3.994 34.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M62.136,96.639A4.954,4.954,0,0,1,63.6,93.112,1,1,0,0,0,62.188,91.7a6.978,6.978,0,0,0,0,9.88,1,1,0,1,0,1.412-1.412A4.958,4.958,0,0,1,62.136,96.639Z",
    transform: "translate(-60.139 -91.407)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(7.987 37.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M122.276,136.323a.992.992,0,0,1,.293-.7,1,1,0,1,0-1.412-1.412,2.991,2.991,0,0,0,0,4.234,1,1,0,0,0,1.412-1.412A.992.992,0,0,1,122.276,136.323Z",
    transform: "translate(-120.279 -133.913)",
    fill: "#7dbaab"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceRecorder);
export default __webpack_public_path__ + "static/media/voice-recorder.1c82cd1654d0bf6299e65b145a44ba6f.svg";
export { ForwardRef as ReactComponent };